import { useTranslation } from 'react-i18next';

import { Description, EmojiWrapper, InfoWrapper, Title, Wrapper } from './CreateQuizCard.styles';

import { useCreateQuizWithNoCourseModalStore } from '@/store';

export const CreateQuizCard = () => {
  const { t } = useTranslation('StudentDashboardTranslations');
  const { setIsOpen } = useCreateQuizWithNoCourseModalStore();
  return (
    <Wrapper onClick={() => setIsOpen(true)}>
      <EmojiWrapper>
        <span role="img" aria-label="target">
          🎯
        </span>
      </EmojiWrapper>
      <InfoWrapper>
        <Title>{t('DO_A_QUIZ')}</Title>
        <Description>{t('DO_A_QUIZ_DESCRIPTION')}</Description>
      </InfoWrapper>
    </Wrapper>
  );
};
